import { Col, Row, Typography } from "antd";
import React, { ReactNode } from "react";
import { Card } from "../card";

export type Props = {
  icon: ReactNode;
  title: ReactNode;
  value: number;
};
const StatusBox = ({ icon, title, value }: Props) => {
  return (
    <Card
      style={{
        boxShadow: "0px 0px 40px rgba(112, 105, 89, 0.1)",
        borderRadius: "10px",
        border: "1px solid #F4F4F4",
        height: "110px",
        width: "248px",
        padding: "16.5px 15.5px",
      }}
      bodyStyle={{
        padding: 0,
      }}
    >
      <Row
        style={{
          width: "100%",
          height: "100%",
          textAlign: "start",
          padding: 0,
        }}
        gutter={8}
        wrap={false}
      >
        <Col>{icon}</Col>
        <Col>
          <Row
            style={{
              padding: 0,
            }}
            justify='space-evenly'
            // spacing='0px'
            // h='100%'
            // w='100%'
            // align={{ base: "center", md: "start" }}
            // justify={{ base: "space-evenly", md: "normal" }}
            gutter={[0, 3]}
          >
            <Col span={24}>
              <Typography.Text
                style={{
                  fontSize: "16px",
                  fontWeight: 600,
                  lineHeight: "28px",
                  color: "criya_blue.900",
                  // align: "initial",
                  whiteSpace: "nowrap",
                }}
              >
                {title}
              </Typography.Text>
            </Col>

            <Col span={24}>
              <Typography.Text
                style={{
                  letterSpacing: "2%",
                  fontSize: "35px",
                  lineHeight: "44px",
                  fontWeight: 900,
                }}
              >
                {value}
              </Typography.Text>
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  );
};

export default StatusBox;
